import styled from '@mui/material/styles/styled';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { useTranslation } from 'react-i18next';

type Props = {
  error?: {
    message: string;
    type: string;
  };
};

export const QuickbookError = ({ error }: Props) => {
  const { t } = useTranslation();

  const errorMessage = error?.message || 'Unknown error';
  const errorType = error?.type || 'Unknown type';
  return (
    <Stack direction="column" gap={1}>
      {error && (
        <Stack direction="column">
          <Typography variant="body1">
            <Bold>{t('editOrder.generateInvoice.quickbooksErrorTitle')}</Bold>
          </Typography>
          <Typography variant="body2">
            <strong>Type:</strong> {errorType}
          </Typography>
          <Typography variant="body2">
            <strong>Message:</strong> {errorMessage}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

const Bold = styled('div')`
  font-weight: 500;
`;
